import { createSelector, defaultMemoize, createSelectorCreator } from 'reselect';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import { isEqual } from 'lodash';
import groupTree from '../../../utils/group-tree';

const defaultSelectors = createMetadataAPISelectors({ name: 'groups' });

const inputSelector = state => state.groups;

const byId = defaultSelectors.byId;

const isLoadingSelector = createSelector(inputSelector, resourceState => resourceState.loading);

const stations = createSelector(defaultSelectors.values, groups => groups.filter(group => group.type == 'station'));

// returns a list of groups that have coordinates defined
const stationsWithCoordinates = createSelector(stations, stations =>
  stations.filter(group => group.coordinates && group.coordinates.latitude)
);

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

// returns a Array with elements:
// [coordinates: {latitude, longitude}, stations: [list of stations]]
const stationsGroupedByCoordinates = createDeepEqualSelector(stationsWithCoordinates, groups => {
  const result = [];
  for (const group of groups) {
    const coords = group.coordinates;
    const key = `${coords.latitude}|${coords.longitude}`;
    let element = result.find(i => i.key == key);
    if (!element) {
      // translate to Google Maps format, where this selector is used
      element = {
        coordinates: { lat: coords.latitude, lng: coords.longitude },
        stations: [],
        key
      };
      result.push(element);
    }
    element.stations.push(group);
  }

  return result;
});

const tree = createSelector(byId, groups => {
  return groupTree(groups);
});

export default {
  ...defaultSelectors,
  tree,
  stations,
  stationsWithCoordinates,
  stationsGroupedByCoordinates,
  isLoadingSelector
};
